// Generated by tools/as3-to-ts from work/decomp/main/scripts/FWP.as (FWP.init_data_arrays, line 2110); hand-edits allowed (see docs/architecture.md)

/** `this.PERKS_DEF` literal from FWP.init_data_arrays. Returns a fresh copy on every call (the game mutates it). */
export function create_PERKS_DEF(): any {
  return {
    "damage_c": {
      "mode": "wptype",
      "id": 1,
      "level": 1,
      "max_lim": 20,
      "upg": new Array<any>(7, 7, 7, 7, 7, 7, 7, 10, 10, 10, 10, 10, 10, 10, 15, 15, 15, 15, 15, 15),
      "name": "Урон ближнего боя"
    },
    "damage_l": {
      "mode": "wptype",
      "id": 17,
      "level": 1,
      "max_lim": 20,
      "upg": new Array<any>(15, 15, 15, 15, 15, 15, 15, 20, 20, 20, 20, 20, 20, 20, 30, 30, 30, 30, 30, 30),
      "name": "Урон живых бомб"
    },
    "damage_e": {
      "mode": "wptype",
      "id": 9,
      "level": 1,
      "max_lim": 20,
      "upg": new Array<any>(20, 20, 20, 20, 20, 20, 20, 30, 30, 30, 30, 30, 30, 30, 40, 40, 40, 40, 40, 40),
      "name": "Урон взрывчатки"
    },
    "damage_a": {
      "mode": "wptype",
      "id": 21,
      "level": 1,
      "max_lim": 20,
      "upg": new Array<any>(25, 25, 25, 25, 25, 25, 25, 36, 36, 36, 36, 36, 36, 36, 50, 50, 50, 50, 50, 50),
      "name": "Урон авиаударов"
    },
    "damage_p": {
      "mode": "wptype",
      "id": 13,
      "level": 1,
      "max_lim": 20,
      "upg": new Array<any>(40, 40, 40, 40, 40, 40, 40, 60, 60, 60, 60, 60, 60, 60, 80, 80, 80, 80, 80, 80),
      "name": "Урон снарядов"
    },
    "damage_f": {
      "mode": "wptype",
      "id": 5,
      "level": 1,
      "max_lim": 20,
      "upg": new Array<any>(60, 60, 60, 60, 60, 60, 60, 90, 90, 90, 90, 90, 90, 90, 120, 120, 120, 120, 120, 120),
      "name": "Урон огнестр. оружия"
    },
    "damage_h": {
      "mode": "wptype",
      "id": 29,
      "level": 1,
      "max_lim": 20,
      "upg": new Array<any>(90, 90, 90, 90, 90, 90, 90, 135, 135, 135, 135, 135, 135, 135, 180, 180, 180, 180, 180, 180),
      "name": "Урон энерг. оружия"
    },
    "god_of_war": {
      "mode": "wptype",
      "id": 48,
      "level": 1,
      "max_lim": 20,
      "upg": new Array<any>(300, 300, 300, 300, 300, 300, 300, 450, 450, 450, 450, 450, 450, 450, 600, 600, 600, 600, 600, 600),
      "name": "Бог войны"
    },
    "angel": {
      "mode": "wpmode",
      "id": 23,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(30, 30, 30),
      "name": "Праведник"
    },
    "electrician": {
      "mode": "wpmode",
      "id": 15,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(40, 40, 40),
      "name": "Электрик"
    },
    "up_pistols": {
      "mode": "wpmode",
      "id": 49,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(50, 50, 50),
      "name": "Дуэлянт"
    },
    "up_rifles": {
      "mode": "wpmode",
      "id": 50,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(100, 100, 100),
      "name": "Охотник"
    },
    "up_miniguns": {
      "mode": "wpmode",
      "id": 51,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(150, 150, 150),
      "name": "Пулеметчик"
    },
    "big_guns": {
      "mode": "wpmode",
      "id": 57,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(180, 180, 180),
      "name": "Крутые пушки"
    },
    "dragonball": {
      "mode": "dother",
      "id": 2,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(5, 5, 5),
      "name": "Шар дракона"
    },
    "fire_punch": {
      "mode": "dother",
      "id": 10,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(7, 7, 7),
      "name": "Огненный удар"
    },
    "light_clips": {
      "mode": "dother",
      "id": 3,
      "level": 1,
      "max_lim": 10,
      "upg": new Array<any>(25, 25, 25, 25, 25, 25, 25, 25, 25, 25),
      "name": "Магазин легких оружий"
    },
    "medium_clips": {
      "mode": "dother",
      "id": 63,
      "level": 1,
      "max_lim": 10,
      "upg": new Array<any>(45, 45, 45, 45, 45, 45, 45, 45, 45, 45),
      "name": "Магазин средних оружий"
    },
    "heavy_clips": {
      "mode": "dother",
      "id": 25,
      "level": 1,
      "max_lim": 10,
      "upg": new Array<any>(65, 65, 65, 65, 65, 65, 65, 65, 65, 65),
      "name": "Магазин тяжелых оружий"
    },
    "poison_res": {
      "mode": "dres",
      "id": 28,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(20, 20, 20),
      "name": "Сопротивление яду/радиации"
    },
    "fire_res": {
      "mode": "dres",
      "id": 24,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(50, 50, 50),
      "name": "Сопротивление огню"
    },
    "para_res": {
      "mode": "dres",
      "id": 20,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(90, 90, 90),
      "name": "Сопротивление парализации"
    },
    "dmg_thr": {
      "mode": "dres",
      "id": 56,
      "level": 1,
      "max_lim": 10,
      "upg": new Array<any>(100, 100, 100, 100, 100, 150, 150, 150, 200, 200),
      "name": "Порог урона"
    },
    "absorb": {
      "mode": "dres",
      "id": 60,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(240, 240, 240),
      "name": "Поглощение урона броней"
    },
    "luck": {
      "mode": "crit",
      "id": 22,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(60, 60, 60),
      "name": "Удача"
    },
    "luck2": {
      "mode": "crit",
      "id": 45,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(140, 140, 140),
      "name": "Удача II"
    },
    "best_crit": {
      "mode": "crit",
      "id": 34,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(160, 160, 160),
      "name": "Лучшие критические"
    },
    "more_fail": {
      "mode": "fail",
      "id": 53,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(20, 20, 20),
      "name": "Больше осечек!"
    },
    "less_fail": {
      "mode": "fail",
      "id": 52,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(50, 50, 50),
      "name": "Обращение с оружием"
    },
    "laser_sights": {
      "mode": "char",
      "id": 6,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(5, 5, 5),
      "name": "Лазерные прицелы"
    },
    "builder": {
      "mode": "char",
      "id": 4,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(10, 10, 10),
      "name": "Строитель"
    },
    "engineer": {
      "mode": "char",
      "id": 11,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(10, 10, 10),
      "name": "Инженер"
    },
    "medic": {
      "mode": "char",
      "id": 19,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(15, 15, 15),
      "name": "Медик"
    },
    "comandeer": {
      "mode": "char",
      "id": 27,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(20, 20, 20),
      "name": "Командир"
    },
    "heavy_guy": {
      "mode": "char",
      "id": 32,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(25, 25, 25),
      "name": "Тяжеловес"
    },
    "thinker": {
      "mode": "char",
      "id": 38,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(30, 30, 30),
      "name": "Вдумчивость"
    },
    "miner": {
      "mode": "char",
      "id": 12,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(40, 40, 40),
      "name": "Минер"
    },
    "sprotsman": {
      "mode": "char",
      "id": 31,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(55, 55, 55),
      "name": "Спортсмен"
    },
    "flyer": {
      "mode": "char",
      "id": 30,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(70, 70, 70),
      "name": "Летчик"
    },
    "fast_walk": {
      "mode": "char",
      "id": 37,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(80, 80, 80),
      "name": "Быстрая ходьба"
    },
    "vampire": {
      "mode": "char",
      "id": 41,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(100, 100, 100),
      "name": "Вампир"
    },
    "fast_temp": {
      "mode": "char",
      "id": 36,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(110, 110, 110),
      "name": "Быстрый темп"
    },
    "accuracy": {
      "mode": "char",
      "id": 33,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(120, 120, 120),
      "name": "Точность"
    },
    "pe": {
      "mode": "char",
      "id": 43,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(130, 130, 130),
      "name": "Восприятие"
    },
    "ninja": {
      "mode": "char",
      "id": 59,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(135, 135, 135),
      "name": "Ниндзя"
    },
    "crates": {
      "mode": "char",
      "id": 58,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(140, 140, 140),
      "name": "Посылки"
    },
    "light_step": {
      "mode": "char",
      "id": 44,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(150, 150, 150),
      "name": "Легкий шаг"
    },
    "morale": {
      "mode": "char",
      "id": 42,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(160, 160, 160),
      "name": "Командный дух"
    },
    "soft_land": {
      "mode": "char",
      "id": 39,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(170, 170, 170),
      "name": "Мягкая посадка"
    },
    "regeneration": {
      "mode": "char",
      "id": 40,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(200, 200, 200),
      "name": "Регенерация"
    },
    "ap_shots": {
      "mode": "char",
      "id": 61,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(250, 250, 250),
      "name": "Пробивные выстрелы"
    },
    "champion": {
      "mode": "int",
      "id": 7,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(30, 30, 30),
      "name": "Чемпион"
    },
    "education": {
      "mode": "int",
      "id": 8,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(35, 35, 35),
      "name": "Образованность"
    },
    "legioner": {
      "mode": "int",
      "id": 26,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(60, 60, 60),
      "name": "Легионер"
    },
    "more_exp": {
      "mode": "int",
      "id": 47,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(120, 150, 200),
      "name": "Мастер боев"
    },
    "steal": {
      "mode": "other",
      "id": 55,
      "level": 1,
      "max_lim": 10,
      "upg": new Array<any>(20, 40, 60, 80, 100, 120, 140, 160, 180, 200),
      "name": "Воровство"
    },
    "stims": {
      "mode": "other",
      "id": 35,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(30, 30, 30),
      "name": "Стимуляторы"
    },
    "gsearch": {
      "mode": "other",
      "id": 62,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(25, 25, 25),
      "name": "Расхититель гробниц"
    },
    "crafting": {
      "mode": "other",
      "id": 14,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(60, 80, 100),
      "name": "Крафтинг"
    },
    "surprise": {
      "mode": "other",
      "id": 16,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(50, 50, 50),
      "name": "Сюрприз"
    },
    "bar": {
      "mode": "other",
      "id": 46,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(55, 55, 55),
      "name": "Барыга"
    },
    "merchant": {
      "mode": "other",
      "id": 18,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(90, 90, 90),
      "name": "Торговец"
    },
    "less_tired": {
      "mode": "other",
      "id": 54,
      "level": 1,
      "max_lim": 3,
      "upg": new Array<any>(100, 150, 200),
      "name": "Неутомимый"
    }
  };
}
